import { useFilters } from "context/FilterContext";
import React from "react";
import styled from "styled-components";
import { SearchIcon } from "ui/icons";
import { ChevronDownIcon } from "ui/icons/inputIcons/ChevronDownIcon";
import { defaultThemeColors, themeColor } from "ui/theme";

const Container = styled.div`
    display: flex;
    align-items: center;
    background-color: ${defaultThemeColors.secondary};
    padding-inline: 12px;
    width: 460px;
    height: auto;
    gap: 1rem;
    border-radius: 99rem;
    margin-left: 15%;
    @media (min-width: 1280px) {
        width: 560px;
    }
`;

const Input = styled.div`
    display: flex;
    align-items: center;
    background-color: white;
    height: 40px;
    padding: 0 1rem;
    border-radius: 999px;
    flex: 1;
    min-width: 0;
    border: 1px solid rgba(25, 29, 58, 0.08);
`;

const Select = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    padding: 0 1rem;
    flex: 1;
    min-width: 0;
    height: 40px;
    border-radius: 999px;
    border: 1px solid rgba(25, 29, 58, 0.08);
    gap: 0.5rem;
`;

const SearchButton = styled.button`
    background-color: ${themeColor("blue")};
    border: none;
    outline: none;
    height: 40px;
    width: 40px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;

    svg {
        color: white;
        font-size: 1rem;
    }
`;

const Placeholder = styled.p`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.5);
    flex: 1;
`;

// This is just a visual placeholder searchBar
const SearchBar = () => {

    const {filters} = useFilters();

    return (
        <Container>
            <Input>
                <Placeholder>{filters?.typeOfClass?.label || "Type the class you are interested in..."}</Placeholder>
            </Input>
            <Select>
                <Placeholder>{filters?.lessonType?.label || "Select lesson type"}</Placeholder>
                <ChevronDownIcon style={{ width: "14px", height: "14px", flexShrink: 0, color: "rgba(0,0,0,0.5)" }} />
            </Select>
            <SearchButton>
                <SearchIcon width={18} height={18}/>
            </SearchButton>
        </Container>
    );
};

export default SearchBar;
